export function SkeletonStatusCards() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="bg-white dark:bg-background-100 rounded-xl border border-background-200 dark:border-background-300 p-4 flex items-center gap-3 animate-pulse">
          <div className="w-2.5 h-2.5 rounded-full bg-background-200 dark:bg-background-300" />
          <div className="space-y-2 flex-1">
            <div className="h-5 w-14 bg-background-200 dark:bg-background-300 rounded-md" />
            <div className="h-3 w-20 bg-background-200 dark:bg-background-300 rounded-md" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function SkeletonTable() {
  return (
    <div className="bg-white dark:bg-background-100 rounded-xl border border-background-200 dark:border-background-300 p-6 animate-pulse">
      <div className="flex items-center justify-between mb-5">
        <div className="space-y-2">
          <div className="h-4 w-36 bg-background-200 dark:bg-background-300 rounded-md" />
          <div className="h-3 w-24 bg-background-200 dark:bg-background-300 rounded-md" />
        </div>
        <div className="h-8 w-24 bg-background-200 dark:bg-background-300 rounded-lg" />
      </div>
      <div className="space-y-3">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="flex items-center gap-4 py-2 border-b border-background-200 dark:border-background-300 last:border-0">
            <div className="h-4 flex-1 bg-background-200 dark:bg-background-300 rounded-md" />
            <div className="h-5 w-16 bg-background-200 dark:bg-background-300 rounded-md" />
            <div className="h-5 w-14 bg-background-200 dark:bg-background-300 rounded-md" />
            <div className="h-5 w-14 bg-background-200 dark:bg-background-300 rounded-md" />
            <div className="h-3 w-28 bg-background-200 dark:bg-background-300 rounded-full" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function SkeletonMap() {
  return (
    <div className="bg-white dark:bg-background-100 rounded-xl border border-background-200 dark:border-background-300 p-6 animate-pulse h-full">
      <div className="space-y-2 mb-5">
        <div className="h-4 w-32 bg-background-200 dark:bg-background-300 rounded-md" />
        <div className="h-3 w-20 bg-background-200 dark:bg-background-300 rounded-md" />
      </div>
      <div className="rounded-lg bg-background-200 dark:bg-background-300 h-[220px]" />
    </div>
  );
}